import { toDateTimeWindowPayload } from 'dashboard/routes/dashboard/settings/automation/dateTimeWindow';

const allElementsString = arr => {
  return arr.every(elem => typeof elem === 'string');
};

const allElementsNumbers = arr => {
  return arr.every(elem => typeof elem === 'number');
};

const normalizeAssignParam = param => {
  if (typeof param !== 'string') return param;
  if (param.startsWith('user:')) return param.replace('user:', '');
  if (param.startsWith('ai_agent:')) return param.replace('ai_agent:', '');
  return param;
};

const formatArray = params => {
  if (params.length <= 0) {
    params = [];
  } else if (allElementsString(params) || allElementsNumbers(params)) {
    params = [...params].map(normalizeAssignParam);
  } else {
    params = params.map(val => normalizeAssignParam(val.id));
  }
  return params;
};

const generatePayloadForObject = item => {
  if (item.action_name === 'date_time_window') {
    item.action_params = [toDateTimeWindowPayload(item.action_params)];
    return item.action_params;
  }

  if (item.action_name === 'assign_team' && item.action_params.team_id) {
    item.action_params = [
      {
        ...item.action_params,
        assignment_logic: item.action_params.assignment_logic || 'round_robin',
        team_id: normalizeAssignParam(item.action_params.team_id.id),
      },
    ];
    return item.action_params;
  }

  if (item.action_name === 'update_contact_tag') {
    item.action_params = [
      {
        operation: item.action_params.operation || 'add',
        tags: (item.action_params.tags || []).map(tag => tag.id || tag),
      },
    ];
    return item.action_params;
  }

  if (item.action_params.id) {
    item.action_params = [normalizeAssignParam(item.action_params.id)];
  } else {
    item.action_params = [item.action_params];
  }
  return item.action_params;
};

const generatePayload = data => {
  const actions = JSON.parse(JSON.stringify(data));
  let payload = actions.map(item => {
    if (Array.isArray(item.action_params)) {
      item.action_params = formatArray(item.action_params);
    } else if (typeof item.action_params === 'object') {
      item.action_params = generatePayloadForObject(item);
    } else if (!item.action_params) {
      item.action_params = [];
    } else {
      item.action_params = [item.action_params];
    }
    return item;
  });
  return payload;
};

export default generatePayload;
